import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type {
  TForgotPasswordRequest,
  TForgotPasswordResponse,
  TResetPasswordRequest,
  TResetPasswordResponse,
  TUpdatePasswordRequest,
  TUpdatePasswordResponse,
} from '/src/lib/types';

export class PasswordService {
  /**
   * Forgot Password
   */
  public static async forgotPassword(req: TForgotPasswordRequest): CancelablePromise<any> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/auth/forgot',
      body: req,
    })) as TForgotPasswordResponse;

    return res;
  }

  /**
   * Reset Password
   */
  public static async resetPassword(token: string, req: TResetPasswordRequest): CancelablePromise<any> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/auth/reset/{token}',
      path: { token },
      body: req,
    })) as TResetPasswordResponse;

    return res;
  }

  /**
   * Update Password
   */
  public static async updatePassword(req: TUpdatePasswordRequest): CancelablePromise<any> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/users/password',
      body: req,
    })) as TUpdatePasswordResponse;

    return res;
  }
}
